import { Directive, ElementRef, Input, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[setFundedColor]'
})
export class SetFundedColorDirective implements AfterViewInit {
  private el: HTMLElement;
  private color;
  percent: number;

  constructor(el: ElementRef) {
    this.el = el.nativeElement;
  }

  @Input()
  set setFundedColor(percent) {
    this.percent = percent;
  }

  ngAfterViewInit() {
    if (this.percent <= 25) {
      this.color = '#10CFBD';
    } else if (this.percent > 25 && this.percent <= 50) {
      this.color = '#48B0F7';
    } else if (this.percent > 50 && this.percent <= 75) {
      this.color = '#F8D053';
    } else {
      this.color = '#F55753';
    }

    this.el.style.backgroundColor = this.color;
  }
}
